import { claimTypes } from '../appsettings';
import { FormConfigInterface } from './interfaces/form-config.interface';
import { strictEmailValidator } from './validators/strict-email.validator';

export const MX_CONFIG: FormConfigInterface = {
  adminCompleteProfile: [
    { Name: 'given_name', Required: () => true, Type: 'text', Order: 1, Hide: () => false },
    { Name: 'family_name', Required: () => true, Type: 'text', Order: 2, Hide: () => false },
    {
      Name: 'email',
      Required: () => true,
      Type: 'text',
      Order: 3,
      Hide: () => false,
      Readonly: true,
    },
    { Name: 'phone', Required: () => true, Type: 'phone', Order: 4, Hide: () => false },
    { Name: 'locale', Required: () => true, Type: 'locale-picker', Order: 5, Hide: () => false },
    { Name: 'gender', Required: () => true, Type: 'gender-picker', Order: 6, Hide: () => false },
  ],
  personalInfo: [
    { Name: 'given_name', Required: () => true, Type: 'text', Order: 0, Hide: () => false },
    { Name: 'family_name', Required: () => true, Type: 'text', Order: 0, Hide: () => false },
    {
      Name: 'date_of_birth',
      Required: () => true,
      Type: 'date-picker',
      Order: 0,
      Readonly: true,
      Hide: () => false,
      CustomLabelTranslationKey: 'dobLabel2',
    },
    { Name: 'gender', Required: () => true, Type: 'gender-picker', Order: 0, Hide: () => false },
    {
      Name: claimTypes.LIS_NUMBER,
      Required: () => true,
      Type: 'text',
      Order: 0,
      Hide: () => false,
    },
  ],
  contact: [
    {
      Name: 'country_address',
      Required: () => false,
      Type: 'country-picker',
      Order: 0,
      Hide: () => false,
    },
    {
      Name: 'city',
      Required: () => false,
      Type: 'text',
      Order: 0,
      Hide: () => false,
    },
    { Name: 'zipcode', Required: () => false, Type: 'text', Order: 0, Hide: () => false },
    { Name: 'address', Required: () => false, Type: 'text', Order: 0, Hide: () => false },
    {
      Name: 'phone',
      Required: () => true,
      Type: 'phone',
      Order: 0,
      Hide: () => false,
      CustomLabelTranslationKey: 'phoneLabel',
    },
    {
      Name: 'email',
      Required: () => true,
      Type: 'text',
      Order: 0,
      Readonly: true,
      Hide: () => false,
      CustomLabelTranslationKey: 'email',
    },
  ],
  accountInfo: [
    {
      Name: claimTypes.EMAIL,
      Required: () => true,
      Type: 'text',
      Order: 0,
      Readonly: false,
      Hide: () => false,
      CustomValidators: [strictEmailValidator],
    },
    {
      Name: 'password',
      Required: () => true,
      Type: 'password',
      Order: 0,
      Readonly: false,
      Hide: () => false,
    },
    {
      Name: 'password-validator',
      Required: () => false,
      Type: 'custom',
      Hide: () => false,
    },
    {
      Name: 'confirmPassword',
      Required: () => true,
      Type: 'password',
      Order: 0,
      Readonly: false,
      Hide: () => false,
    },
  ],
  completeProfile: [
    {
      Name: claimTypes.EE_NOTIFICATION_LANGUAGE,
      Required: () => false,
      Type: 'text',
      Order: 0,
      Hide: () => true,
      DefaultValue: () => 'es-MX',
    },
    {
      Name: claimTypes.GIVEN_NAME,
      Required: () => true,
      Type: 'text',
      Order: 0,
      Hide: () => false,
    },
    {
      Name: claimTypes.FAMILY_NAME,
      Required: () => true,
      Type: 'text',
      Order: 0,
      Hide: () => false,
    },
    {
      Name: claimTypes.PHONE,
      Required: () => true,
      Type: 'phone',
      Order: 0,
      Hide: () => false,
    },
    {
      Name: claimTypes.LOCALE,
      Required: () => true,
      Type: 'locale-picker',
      Order: 0,
      Hide: () => false,
      Disabled: true,
      DefaultValue: () => 'es-MX',
    },
    {
      Name: claimTypes.DATE_OF_BIRTH,
      Required: () => true,
      Type: 'date-picker',
      Order: 0,
      Readonly: false,
      Hide: () => false,
    },
    {
      Name: claimTypes.GENDER,
      Required: () => true,
      Type: 'radio-group',
      Order: 0,
      Hide: () => false,
    },
    {
      Name: claimTypes.LIS_NUMBER,
      Required: () => true,
      Type: 'text',
      Order: 0,
      Hide: () => false,
    },
  ],
};

export default MX_CONFIG;
